<app-legal-layout
  eyebrow="Rechtliches · Endkunden"
  title="Allgemeine Geschäftsbedingungen"
  lastUpdated="Juni 2026">

  <h2>§ 1 Geltungsbereich, Begriffsbestimmungen</h2>
  <p>
    (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für die Nutzung der
    Online-Plattform <strong>get-craftly.de</strong> (nachfolgend „Plattform" oder „Craftly"),
    betrieben von der Kulatrix UG (haftungsbeschränkt), Alarichstraße 18, 42281 Wuppertal
    (nachfolgend „Anbieter" oder „wir") durch Endkunden.
  </p>
  <p>
    (2) <strong>Endkunde</strong> im Sinne dieser AGB ist eine natürliche Person, die die Plattform zu
    privaten Zwecken nutzt (Verbraucher gemäß § 13 BGB). Diese AGB gelten nicht für Handwerker; für
    diese gelten <a routerLink="/agb/handwerker">gesonderte AGB</a>.
  </p>
  <p>
    (3) <strong>Handwerker</strong> sind Unternehmer im Sinne von § 14 BGB, die über die Plattform
    Dienstleistungen anbieten.
  </p>
  <p>
    (4) Abweichende Bedingungen des Endkunden werden nicht anerkannt, es sei denn, wir stimmen ihrer
    Geltung ausdrücklich schriftlich zu.
  </p>

  <h2>§ 2 Leistungsgegenstand</h2>
  <p>
    (1) Craftly betreibt eine <strong>Vermittlungsplattform</strong> für Handwerksleistungen. Über die
    Plattform können Endkunden Anfragen für Handwerksleistungen stellen, von Handwerkern Festpreis-Angebote
    erhalten und ein Angebot annehmen, woraus eine <strong>Buchung</strong> entsteht.
  </p>
  <p>
    (2) <strong>Wichtig:</strong> Craftly wird selbst nicht Vertragspartei der vermittelten
    Handwerksleistung. Der Vertrag über die Erbringung der Handwerksleistung kommt
    <strong>ausschließlich zwischen Endkunde und dem jeweiligen Handwerker</strong> zustande. Wir
    treten weder als Auftragnehmer noch als Stellvertreter der Handwerker auf.
  </p>
  <p>(3) Die Nutzung der Plattform durch Endkunden ist <strong>kostenlos</strong>. Eine Vergütung wird ausschließlich vom Handwerker erhoben.</p>
  <p>(4) Wir prüfen Anfragen und Angebote nicht inhaltlich. Eine Gewähr für Qualifikation, Zuverlässigkeit oder Leistungsfähigkeit der Handwerker übernehmen wir nicht, soweit nachfolgend nicht anders geregelt.</p>

  <h2>§ 3 Registrierung, Nutzerkonto</h2>
  <p>(1) Für die Nutzung der Plattform ist ein Nutzerkonto erforderlich. Die Registrierung steht ausschließlich volljährigen, geschäftsfähigen Personen offen. Pro Person ist nur ein Konto zulässig.</p>
  <p>(2) Die Registrierung erfolgt durch Eingabe der erforderlichen Daten oder über einen unterstützten OAuth-Anbieter (Google, Apple). Mit Abschluss der Registrierung kommt ein <strong>Nutzungsvertrag</strong> zwischen Endkunde und Anbieter über die kostenlose Nutzung der Plattform zustande.</p>
  <p>(3) Der Endkunde ist verpflichtet, bei der Registrierung wahrheitsgemäße und vollständige Angaben zu machen und diese aktuell zu halten.</p>
  <p>(4) Zugangsdaten sind geheim zu halten. Bei Verdacht auf Missbrauch ist das Passwort unverzüglich zu ändern und uns zu informieren.</p>

  <h2>§ 4 Anfrage, Vertragsschluss zwischen Endkunde und Handwerker</h2>
  <p>(1) Der Endkunde stellt seine Anfrage über den geführten Wizard. Die Anfrage stellt <strong>kein verbindliches Angebot</strong> dar, sondern eine unverbindliche Einladung an passende Handwerker, ein Angebot abzugeben (invitatio ad offerendum).</p>
  <p>(2) Handwerker, die im definierten Umkreis tätig sind, erhalten die Anfrage in eingeschränkter Form (ohne genaue Straße) und können ein Festpreis-Angebot abgeben.</p>
  <p>(3) Mit Annahme eines Angebots durch den Endkunden über die Plattform-Funktion „Angebot annehmen" kommt der <strong>Werk- bzw. Dienstleistungsvertrag direkt zwischen Endkunde und dem ausgewählten Handwerker</strong> zustande. Vertragsinhalt sind die Angaben aus Anfrage und Angebot, ggf. ergänzt durch zwischen den Parteien getroffene Absprachen.</p>
  <p>(4) Nach Buchung werden die für die Auftragsdurchführung erforderlichen Kontaktdaten (vollständige Adresse, Telefonnummer) zwischen den Parteien ausgetauscht.</p>

  <h2>§ 5 Pflichten des Endkunden</h2>
  <p>(1) Der Endkunde verpflichtet sich, in seinen Anfragen und sonstigen Angaben wahrheitsgemäße und vollständige Informationen zu geben, die für eine ordnungsgemäße Leistungserbringung relevant sind.</p>
  <p>(2) Der Endkunde stellt sicher, dass am Leistungsort die für die Auftragsdurchführung erforderlichen Voraussetzungen bestehen (z. B. Zugang, Strom, Wasser, ggf. Genehmigungen).</p>
  <p>(3) Der Endkunde wird Handwerker im Rahmen der Plattform-Funktionen sachlich behandeln. Beleidigende, diskriminierende oder rechtswidrige Inhalte sind untersagt.</p>
  <p>(4) Hochgeladene Inhalte (z. B. Fotos, Beschreibungen) dürfen keine Rechte Dritter verletzen. Der Endkunde versichert, an hochgeladenen Inhalten die erforderlichen Rechte zu haben, und räumt dem Anbieter ein einfaches, auf den Plattformbetrieb beschränktes Nutzungsrecht ein.</p>

  <h2>§ 6 Rechnungsstellung und Zahlung</h2>
  <p>(1) Vertragspartner des Endkunden für die Werkleistung ist ausschließlich der vermittelte Handwerker. Kulatrix UG (haftungsbeschränkt) ist nicht Vertragspartner des Werkvertrags, sondern Vermittler und — bezüglich der Zahlung — Treuhänder im Auftrag des Handwerkers.</p>
  <p>(2) Die Rechnung über die Werkleistung wird im Namen des Handwerkers erstellt und dem Endkunden elektronisch (PDF) per E-Mail und im Kundenkonto bereitgestellt. Eine Zustellung in Papierform erfolgt nicht.</p>
  <p>(3) Die Zahlung erfolgt im Voraus über die Treuhand-Zahlungsabwicklung (Stripe Payments Europe Ltd.). Mit Annahme eines Angebots autorisiert der Endkunde die Belastung des gewählten Zahlungsmittels in Höhe des Brutto-Festpreises.</p>
  <p>(4) Der Betrag wird treuhänderisch gehalten und frühestens 24 Stunden nach Fertigstellungsmeldung des Handwerkers an diesen freigegeben, sofern der Endkunde innerhalb dieser Frist keine begründete Reklamation gemäß § 9a (Mängelmeldung und Vermittlungsverfahren) erhebt. Bestätigt der Endkunde die Fertigstellung ausdrücklich, erfolgt die Freigabe sofort.</p>
  <p>(5) Erhebt der Endkunde fristgerecht eine begründete Reklamation, bleibt der Betrag bis zur Klärung nach § 9a im Treuhand-Hold. Eine Auszahlung oder Rückerstattung erfolgt ausschließlich nach den dort beschriebenen Verfahren.</p>
  <p>(6) Rückerstattungen erfolgen auf das ursprünglich verwendete Zahlungsmittel; der Zeitpunkt der Wertstellung richtet sich nach dem Zahlungsdienstleister.</p>
  <p>(7) Die Nutzung der Plattform ist für den Endkunden kostenlos; eine Provision wird ausschließlich vom Handwerker erhoben (§ 2 Abs. 3).</p>

  <h2>§ 7 Bewertungen</h2>
  <p>(1) Endkunden können Handwerker nach Abschluss eines Auftrags bewerten. Bewertungen müssen wahrheitsgemäß und sachlich sein.</p>
  <p>(2) Bewertungen können ausschließlich von Endkunden abgegeben werden, die einen Auftrag über Craftly abgeschlossen haben (verifizierte Bewertungen). Eine inhaltliche Vorabprüfung erfolgt nicht; wir sind jedoch berechtigt, Bewertungen nach Eingang zu prüfen und unzulässige Inhalte (z. B. Schmähkritik, Falschbehauptungen, Werbung) zu entfernen. Bewertungen werden weder durch uns noch durch Dritte incentiviert.</p>

  <h2>§ 7a Reihenfolge der Suchergebnisse (Transparenz)</h2>
  <p>(1) Werden Handwerker in einer Suche oder Liste sortiert oder empfohlen, geschieht dies anhand der nachfolgenden Hauptparameter (Art. 27 DSA, Art. 5 P2B-VO). Die Reihenfolge entspricht der Gewichtung — frühere Parameter haben einen höheren Einfluss als spätere:</p>
  <ol>
    <li>geografische Entfernung zwischen Leistungsort und Handwerker (PostGIS-Umkreis),</li>
    <li>Verifizierungsstatus (verifizierte Betriebe vor unverifizierten),</li>
    <li>Aktivitätsstatus / Verfügbarkeit (aktive Profile vor pausierten oder im Urlaub befindlichen),</li>
    <li>Bewertungs-Durchschnitt (sobald genügend Bewertungen vorliegen),</li>
    <li>Antwortzeit auf Anfragen (sobald aktiviert).</li>
  </ol>
  <p>(2) Eine bezahlte Sichtbarkeit oder bevorzugte Platzierung gegen Entgelt findet derzeit nicht statt. Sollten wir künftig solche Modelle einführen, kennzeichnen wir betroffene Einträge ausdrücklich als „Anzeige" oder „Gesponsert" und passen diese AGB entsprechend an.</p>

  <h2>§ 8 Stornierung, Vertragsbeendigung mit Handwerker</h2>
  <p>(1) Eine Stornierung oder Anpassung gebuchter Leistungen ist mit dem Handwerker direkt zu klären. Bei Streitigkeiten unterstützen wir auf Anfrage in vermittelnder Funktion, übernehmen jedoch keine Entscheidung in der Sache.</p>
  <p>(2) Beidseitige gesetzliche Rechte (Mängelrechte, Rücktritts- und Kündigungsrechte) gegenüber dem Handwerker bleiben unberührt.</p>

  <h2>§ 9 Mängelhaftung des Handwerkers</h2>
  <p>
    (1) Für die vom Handwerker erbrachten Werk- und Dienstleistungen gelten die gesetzlichen
    Mängelrechte (§§ 633 ff. BGB). Die Verjährungsfrist beträgt
    <strong>fünf Jahre bei Arbeiten an einem Bauwerk</strong> und ansonsten
    <strong>zwei Jahre</strong> ab Abnahme (§ 634a BGB).
  </p>
  <p>
    (2) Im Mängelfall ist der Handwerker zunächst zur <strong>Nacherfüllung</strong> berechtigt und
    verpflichtet. Schlägt diese fehl, kann der Endkunde nach Maßgabe der gesetzlichen Vorschriften
    Selbstvornahme verlangen, den Werklohn mindern, vom Vertrag zurücktreten oder Schadensersatz
    fordern (§§ 634, 637 BGB).
  </p>
  <p>
    (3) Die plattformseitige Auszahlung des Werklohns an den Handwerker nach Ablauf des
    24-Stunden-Veto-Fensters (siehe Buchungs- und Abrechnungsprozess) lässt die gesetzlichen
    Mängelrechte des Endkunden gegenüber dem Handwerker <strong>unberührt</strong>; sie stellt
    insbesondere keinen Verzicht auf die Geltendmachung von Mängelansprüchen dar.
  </p>
  <p>
    (4) Mängelansprüche sind unmittelbar gegenüber dem Handwerker geltend zu machen. Wir unterstützen
    auf Anfrage in vermittelnder Funktion, übernehmen jedoch keine Entscheidung in der Sache.
  </p>

  <h2>§ 9a Mängelmeldung über die Plattform und Vermittlungsverfahren</h2>
  <p>
    (1) Stellt der Endkunde bei Abnahme oder innerhalb von <strong>24 Stunden</strong> nach Abschluss
    der Werkleistung Mängel fest, kann er diese über die Funktion „Mängel melden" in seinem Kundenkonto
    anzeigen. Die rechtzeitige Anzeige unterbricht die automatische Auszahlung des Werklohns an den
    Handwerker für die Dauer der Klärung.
  </p>
  <p>
    (2) Mit der Mängelmeldung wird ein strukturiertes Vermittlungsverfahren zwischen Endkunde und
    Handwerker eingeleitet. Der Handwerker erhält <strong>48 Stunden</strong> Zeit, um auf die
    Meldung zu reagieren. Reagiert der Handwerker nicht innerhalb dieser Frist, wird der Endkunde
    automatisch in voller Höhe entschädigt.
  </p>
  <p>
    (3) Im Vermittlungsverfahren stehen folgende Lösungen zur Verfügung:
  </p>
  <ul>
    <li>Nachbesserung durch den Handwerker</li>
    <li>Teilweise Rückerstattung</li>
    <li>Vollständige Rückerstattung</li>
  </ul>
  <p>
    (4) Kommt es zwischen Endkunde und Handwerker zu keiner Einigung, prüft das Service-Team von
    Kulatrix UG den Fall anhand der vorgelegten Beweise und trifft eine Entscheidung. Diese
    Entscheidung ist für beide Seiten <strong>im Verhältnis zur Plattform</strong> verbindlich;
    gesetzliche Rechte des Endkunden gegen den Handwerker (insbesondere Gewährleistungsansprüche
    nach §§ 633 ff. BGB) bleiben hiervon unberührt.
  </p>
  <p>
    (5) Die Mängelmeldung kann nicht für Mängel verwendet werden, die offensichtlich bei Abnahme
    erkennbar waren und vom Endkunden vorbehaltlos akzeptiert wurden, es sei denn, es handelt sich
    um <strong>verdeckte Mängel</strong>, die erst später entdeckt werden konnten. Verdeckte Mängel
    können bis zu <strong>30 Tage nach Abschluss</strong> gemeldet werden.
  </p>
  <p>
    (6) Missbräuchliche oder offensichtlich unbegründete Mängelmeldungen können zur Kontosperre und
    zum Ausschluss vom weiteren Gebrauch der Plattform führen. Bei wiederholt unbegründeten
    Forderungen behält sich Kulatrix UG vor, weitere Mängelmeldungen nur noch nach manueller Prüfung
    anzunehmen.
  </p>
  <p>
    (7) Bei Schäden ab <strong>500 €</strong> gilt die Berufshaftpflichtversicherung des Handwerkers
    als primäre Anspruchsgrundlage. Kulatrix UG unterstützt den Endkunden bei der Schadensmeldung an
    den Handwerker und dessen Versicherung, tritt jedoch selbst nicht als Versicherer oder
    Schadensregulierer auf.
  </p>
  <p>
    (8) Wird der Treuhand-Betrag infolge des Verfahrens freigegeben, gemindert oder erstattet,
    erstellt die Plattform die erforderlichen Korrekturbelege automatisch (Storno-/Korrekturrechnung
    an den Endkunden, Storno-Gutschrift an den Handwerker, jeweils unter Bezug auf den Originalbeleg
    mit dem Zusatz „-S"). Bei Teilrückerstattung wird anteilig korrigiert.
  </p>

  <h2>§ 10 Widerrufsrecht</h2>
  <p>
    Endkunden steht ein gesetzliches Widerrufsrecht hinsichtlich des
    <strong>Nutzungsvertrags mit dem Anbieter</strong> sowie hinsichtlich des
    <strong>Vertrags mit dem Handwerker</strong> zu, sofern dieser außerhalb von Geschäftsräumen oder
    im Fernabsatz geschlossen wurde. Einzelheiten und das Muster-Widerrufsformular finden Sie in der
    <a routerLink="/widerruf">Widerrufsbelehrung</a>.
  </p>

  <h2>§ 11 Haftung des Anbieters</h2>
  <p>(1) Wir haften unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, für vorsätzliches oder grob fahrlässiges Verhalten sowie nach dem Produkthaftungsgesetz.</p>
  <p>(2) Bei einfacher Fahrlässigkeit haften wir nur bei Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht), deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Endkunde regelmäßig vertrauen darf. In diesem Fall ist die Haftung auf den vorhersehbaren, vertragstypischen Schaden begrenzt.</p>
  <p>(3) Eine darüber hinausgehende Haftung – insbesondere für Schäden, die aus der Vertragsbeziehung zwischen Endkunde und Handwerker entstehen – ist ausgeschlossen.</p>

  <h2>§ 12 Verfügbarkeit</h2>
  <p>Wir sind bemüht, einen unterbrechungsfreien Betrieb der Plattform sicherzustellen, schulden eine ständige Verfügbarkeit jedoch nicht. Wartungsfenster und unvorhergesehene Ausfälle bleiben vorbehalten.</p>

  <h2>§ 13 Kündigung des Nutzungsvertrags</h2>
  <p>(1) Der Endkunde kann sein Nutzerkonto jederzeit ohne Frist über die Funktion „Konto löschen" beenden.</p>
  <p>(2) Wir können den Nutzungsvertrag mit einer Frist von 14 Tagen ordentlich kündigen. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt; ein wichtiger Grund liegt insbesondere bei wiederholtem oder schwerwiegendem Verstoß gegen diese AGB vor.</p>
  <p>(3) Laufende Buchungen bleiben von der Kündigung unberührt und sind vertragsgemäß abzuwickeln.</p>

  <h2>§ 14 Datenschutz</h2>
  <p>
    Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer
    <a routerLink="/datenschutz">Datenschutzerklärung</a>.
  </p>

  <h2>§ 15 Änderungen der AGB</h2>
  <p>(1) Wir können diese AGB ändern, soweit dies aufgrund einer Änderung der Rechtslage, höchstrichterlicher Rechtsprechung, der Marktgegebenheiten oder zur Schließung von Regelungslücken erforderlich ist und der Endkunde dadurch nicht unangemessen benachteiligt wird.</p>
  <p>(2) Änderungen werden mindestens 6 Wochen vor Inkrafttreten per E-Mail mitgeteilt. Widerspricht der Endkunde nicht innerhalb von 6 Wochen ab Zugang der Mitteilung, gelten die Änderungen als angenommen. Auf das Widerspruchsrecht und die Folgen des Schweigens werden wir in der Mitteilung gesondert hinweisen.</p>

  <h2>§ 15a Verbraucherschlichtung und Online-Streitbeilegung</h2>
  <p>
    (1) Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.
  </p>
  <p>
    (2) Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle ist
    Kulatrix UG weder bereit noch verpflichtet. Hiervon unberührt bleibt das plattforminterne
    Reklamations- und Vermittlungsverfahren gemäß § 9a sowie das Recht des Endkunden, seine
    gesetzlichen Ansprüche gegenüber dem Handwerker geltend zu machen.
  </p>

  <h2>§ 16 Schlussbestimmungen</h2>
  <p>(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Zwingende Verbraucherschutzvorschriften des Staates, in dem der Endkunde seinen gewöhnlichen Aufenthalt hat, bleiben unberührt.</p>
  <p>(2) Sollte eine Bestimmung dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
  <p>(3) Sofern der Endkunde keinen Wohnsitz in der EU hat oder sein Wohnsitz oder gewöhnlicher Aufenthalt zum Zeitpunkt der Klageerhebung unbekannt ist, ist Gerichtsstand Düsseldorf.</p>

</app-legal-layout>
